import gsap from "gsap";
import { defineStore } from "pinia";

export type State = {
  topPosition: number,
  message: string,
}

const animationDuration = 0.3
const showPosition = 40
const hidePosition = -100
const durationForAutoClose = 7000

export const useNotificationStore = defineStore('notification', {
  state: (): State => {
    return {
      topPosition: hidePosition,
      message: '',
    }
  },
  actions: {
    showNotification(
      message: string = 'カレンダーに追加しました',
      autoClose: boolean = true
    ) {
      this.message = message
      gsap.to(this, {
        duration: animationDuration,
        topPosition: showPosition,
        ease: 'easeOut'
      })
      if (autoClose) {
        setTimeout(() => {
          this.hideNotification()
        }, durationForAutoClose)
      }
    },
    hideNotification() {
      gsap.to(this, {
        duration: animationDuration,
        topPosition: hidePosition,
        ease: 'easeOut'
      })
    }
  }
})
